module.exports = __webpack_public_path__ + "static/media/TN-Men-Sneakers-2.0-OA.fd410fac.svg";